import { useEffect, useState } from 'react';

export function useHeaderController(
  heroSelector = '#hero',
  { hideOffset = 120, rootMarginTop = 64 } = {}
) {
  const [overHero, setOverHero] = useState(false); // на первом экране?
  const [hidden, setHidden] = useState(false);     // спрятан из-за скролла вниз?

  // следим, пересекается ли хедер с hero (когда да — делаем его прозрачным)
  useEffect(() => {
    const heroEl = document.querySelector(heroSelector);
    if (!heroEl || !('IntersectionObserver' in window)) {
      setOverHero(false);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        setOverHero(entry.isIntersecting);
        if (entry.isIntersecting) setHidden(false); // на hero всегда показываем
      },
      { root: null, rootMargin: `-${rootMarginTop}px 0px 0px 0px`, threshold: 0 }
    );
    io.observe(heroEl);
    return () => io.disconnect();
  }, [heroSelector, rootMarginTop]);

  // headroom-поведение: вниз — спрятать, вверх — показать
  useEffect(() => {
    let lastY = window.pageYOffset;
    let raf = 0;

    const run = () => {
      const y = window.pageYOffset;
      const dy = y - lastY;

      if (Math.abs(dy) > 5) {
        if (dy > 0 && y > hideOffset && !overHero) {
          setHidden(true);
        } else if (dy < 0) {
          setHidden(false);
        }
        lastY = y;
      }
      raf = 0;
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(run);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    run(); // первичная инициализация

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [overHero, hideOffset]);

  return { overHero, hidden };
}